import React from 'react';
import { SvgIcon } from '../SvgIcon';

export default React.memo(
	React.forwardRef((props: any, ref: any) => {
		return (
			<SvgIcon data-testid={`${'FeedbackError'}Icon`} ref={ref} {...props}>
				<path style={{ color: 'inherit' }} transform="scale(1,1)" d="M671.147 896h-318.293l-224.853-224.853v-318.293l224.853-224.853h318.293l224.853 224.853v318.293l-224.853 224.853zM725.333 352.427l-53.76-53.76-159.573 159.573-159.573-159.573-53.76 53.76 159.573 159.573-159.573 159.573 53.76 53.76 159.573-159.573 159.573 159.573 53.76-53.76-159.573-159.573 159.573-159.573z" />
			</SvgIcon>
		);
	}),
);

export const FeedbackError = React.memo(
	React.forwardRef((props: any, ref: any) => {
		return (
			<SvgIcon data-testid={`${'FeedbackError'}Icon`} ref={ref} {...props}>
				<path style={{ color: 'inherit' }} transform="scale(1,1)" d="M671.147 896h-318.293l-224.853-224.853v-318.293l224.853-224.853h318.293l224.853 224.853v318.293l-224.853 224.853zM725.333 352.427l-53.76-53.76-159.573 159.573-159.573-159.573-53.76 53.76 159.573 159.573-159.573 159.573 53.76 53.76 159.573-159.573 159.573 159.573 53.76-53.76-159.573-159.573 159.573-159.573z" />
			</SvgIcon>
		);
	}),
);
